import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import HorizontalSlider from "../common/components/HorizontalSlider";
import { howMakeChange } from "../features/listenerProfile";
import VerticalCenter from "../common/components/VerticalCenter";
import Center from "../common/components/Center";
import Padding from "../common/components/Padding";

export default function Question2MakeChange() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <>
      <Padding>
        <Center>
          <h1>
            {t(
              "In general, does change happen to you or do you make change happen?"
            )}
          </h1>
        </Center>
      </Padding>
      <VerticalCenter>
        <HorizontalSlider
          leftElement={<p>{t("It happens to me")}</p>}
          values={[1, 2.33, 3.66, 5]}
          defaultValue={2.33}
          onChange={(value) => dispatch(howMakeChange(value))}
          rightElement={<p>{t("I make it happen")}</p>}
        />
      </VerticalCenter>
    </>
  );
}
